import * as Yup from "yup"
import i18next from "i18next"

export const FindServiceSchema = Yup.object({
    premise_id: Yup.string().required(i18next.t('findService.error_premise')),
    service_category: Yup.string().required(i18next.t('findService.error_service_category')),
    service_name: Yup.string().trim().required(i18next.t('findService.error_service_name')),
    mobile_number: Yup.string()
        .matches(/^[0-9]+$/, i18next.t('findService.error_invalid_mobile'))
        .required(i18next.t('findService.error_mobile_number')),
    alternative_contact: Yup.string()
        .matches(/^[0-9]*$/, i18next.t('findService.error_invalid_alt_contact'))
        .notRequired(),
    email: Yup.string().email(i18next.t('findService.error_invalid_email')).notRequired(),
    description: Yup.string().notRequired(),
    address: Yup.string().notRequired(),
    status: Yup.string().required(i18next.t('findService.error_status')),
})